export const getTimeFromTimestamp = (timestamp) => {
  const dateObj = new Date(timestamp);
  const formattedDate = dateObj.toLocaleTimeString();
  return formattedDate;
};
